module.exports = __webpack_public_path__ + "img/swiper_04.383693dd.jpg";